/** Lightweight bus so settings fields can drive the floating mobile preview. */
const boot_listeners = new Set();
const screen_listeners = new Set();

/** Kronos ScreensSettings ids → navigation.tabs[].target */
export const SETTINGS_SCREEN_TO_NAV_TARGET = {
    home: 'Home',
    program: 'Programme',
    news: 'News',
    tickets: 'Ticket',
    shop: 'SteamShop',
    cart: 'Panier',
    favorites: 'Favoris',
    ratings: 'Votes',
};

export function request_mobile_preview_boot() {
    boot_listeners.forEach((fn) => {
        try {
            fn();
        } catch (_e) { /* ignore */ }
    });
}

export function subscribe_mobile_preview_boot(fn) {
    boot_listeners.add(fn);
    return () => boot_listeners.delete(fn);
}

/**
 * Ask the preview dock to show a screen.
 * @param {string} screen_or_target Settings screen id (`home`) or nav target (`Home`)
 */
export function request_mobile_preview_screen(screen_or_target) {
    if (!screen_or_target)
        return;
    const target = SETTINGS_SCREEN_TO_NAV_TARGET[screen_or_target] || screen_or_target;
    screen_listeners.forEach((fn) => {
        try {
            fn(target);
        } catch (_e) { /* ignore */ }
    });
}

export function subscribe_mobile_preview_screen(fn) {
    screen_listeners.add(fn);
    return () => screen_listeners.delete(fn);
}
